import VALIDATORS from '@validators/all';

import { BANK_CODES } from '@js/constants/banks';

import RULES from '../javascripts/rules';

function _rules(props, planter, validation) {
  const unknown = props.banks.some((code) => !BANK_CODES.includes(code));
  const keys = Object.keys(validation.rules || {});

  return keys
    .filter((code) => unknown || !keys.length || props.banks.includes(code))
    .reduce((reduced, code) => {
      reduced[code] = validation.rules[code];

      return reduced;
    }, {});
}

function _overruled(props, planter, validation) {
  const {
    values,
    properties,
  } = planter;

  function iterate(rule, operation) {
    if (Array.isArray(rule)) {
      return rule[operation === 'or' ? 'some' : 'every']((i) => iterate(i, 'and'));
    }

    return RULES[rule.rule](
      values.value[rule.field],
      rule,
      properties.value[rule.field]?.options,
    );
  }

  return !Object
    .values(_rules(props, planter, validation))
    .some((i) => iterate(i, 'or'));
}

export default function validator(props, planter) {
  const {
    leaves,
    properties,
    values,
    errors,
  } = planter;

  function invalidate(name) {
    let message;

    leaves.value[name].validations?.forEach((v) => {
      if (message) {
        return;
      }

      if (v.type === 'ruled' && _overruled(props, planter, v)) {
        return;
      }

      const validation = { ...v };
      const label = properties
        .value[name]
        .options
        ?.find((i) => i.value === values.value[name])
        ?.label;

      if (label && properties.value[name].type === 'select') {
        validation.extra = [
          label,
          props.domains[leaves.value[name].domain]?.find((i) => i.name === label)?.identifier,
        ].filter((i) => i);
      }

      if (VALIDATORS[validation.type](values.value[name], validation)) {
        message = VALIDATORS[validation.type].message(values.value[name], validation);
      }
    });

    errors.value[name] = message;
  }

  return {
    invalidate,
  };
}
